import { STRUCTURED_FORMS } from "./InboxStructuredFieldsForm";

const FIELD_LABELS: Record<string, string> = {
  ...Object.fromEntries(Object.values(STRUCTURED_FORMS).flatMap((form) => form.fields.map((field) => [field.key, field.label]))),
  employment_type: "Vrsta zaposlenja",
  record_id: "Postojeći strukturirani zapis",
  correction_reason: "Razlog ispravka",
  document_type_code: "Vrsta dokumenta",
  mode: "Način potvrde",
  categories: "Kategorije vozačke dozvole",
  kategorija: "Kategorija vozačke dozvole",
  issued_on: "Datum izdavanja",
  expires_on: "Datum isteka",
};

export function missingFieldLabels(fields: string[]): string {
  return [...new Set(fields.map((path) => FIELD_LABELS[path.split(".").at(-1) ?? ""] ?? "Označena polja"))].join(", ");
}

export function inboxAiError(message: string): string {
  return message.replace(/^(?:classification|structured|recovery|preparation):\s*(?:timeout|auth|rate_limit|bad_request|other|network|schema):\s*/, "");
}
